import { Merchant } from "../../supplier/reporting/merchants/merchantTypes"
import { useApiQuery } from "../../../core/api/useApiQuery"
import { fetchEntityDetailsById, SupportEntityQuery } from "../../support/admin/entities/supportEntityApi"
import { Collapse, Grid, Skeleton, TableCell, TableRow, Typography } from "@mui/material"
import React from "react"
import { makeStyles } from "tss-react/mui"
import { tailwindPalette } from "../../theme/tailwindPalette"
import { LocalizedStrict } from "../../localization/components/AppLocalized"

const useStyles = makeStyles()((_theme) => ({
    tableCell: { paddingBottom: 0, paddingTop: 0 },
    entityTitle: {
        fontWeight: "bold",
        marginBottom: ".5rem",
    },
    entityEmpty: {
        color: tailwindPalette.gray[500],
    },
    wrapList: {
        borderLeft: `.25rem solid ${tailwindPalette.slate[200]}`,
        paddingLeft: "1rem",
    },
}))

export function MerchantTableRowDetails({ merchant, open }: { merchant: Merchant; open: boolean }) {
    const { classes } = useStyles()
    const { data: entity, isLoading } = useApiQuery(fetchEntityDetailsById, {
        queryName: SupportEntityQuery.DETAILS_FOR_ENTITY,
        dependencies: {
            entityId: merchant.id,
        },
        select: (data) => data.entity,
        enabled: Boolean(merchant.id) && open,
    })

    return (
        <TableRow>
            <TableCell className={classes.tableCell} colSpan={6}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Grid m="1rem">
                        {isLoading ? (
                            <Skeleton width="50%" height={30} />
                        ) : (
                            <Grid className={classes.wrapList} container direction="column">
                                {entity?.entityDetails.connectedCompanies ? (
                                    <>
                                        <LocalizedStrict id="supplier-merchant-access-table-details-customers-title">
                                            <Typography className={classes.entityTitle}>Customers:</Typography>
                                        </LocalizedStrict>
                                        {entity?.entityDetails.connectedCompanies.map((company, index) => (
                                            <Grid item key={index}>
                                                <Typography>{company.name}</Typography>
                                            </Grid>
                                        ))}
                                    </>
                                ) : (
                                    <LocalizedStrict id="supplier-merchant-access-table-details-no-companies">
                                        <Typography className={classes.entityEmpty}>
                                            There are no connected companies
                                        </Typography>
                                    </LocalizedStrict>
                                )}
                            </Grid>
                        )}
                    </Grid>
                </Collapse>
            </TableCell>
        </TableRow>
    )
}
